import { render, staticRenderFns } from "./OtherSpecialityFilters.vue?vue&type=template&id=49622e48&"
import script from "./OtherSpecialityFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OtherSpecialityFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49622e48')) {
      api.createRecord('49622e48', component.options)
    } else {
      api.reload('49622e48', component.options)
    }
    module.hot.accept("./OtherSpecialityFilters.vue?vue&type=template&id=49622e48&", function () {
      api.rerender('49622e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/OtherSpecialityFilters/OtherSpecialityFilters.vue"
export default component.exports